import PropTypes from 'prop-types';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import countSuffix from '@/helpers/countSuffix';
import { IndexerKpiCard } from '@/app/Indexer/components/IndexerKpiCard';
import TextLoading from '@/app/common/components/skeleton/TextLoading';
import './backlinkKpiCards.css';

const BackLinkCount = ({ count, loading = false }: Record<string, any>) => {
  return (
    <IndexerKpiCard tone="primary" imageIndex={0} className="h-100">
      <div className="overview-kpi-value position-relative">
        {loading ? (
          <>
            <span className="invisible" aria-hidden>
              0
            </span>
            <span
              className="position-absolute top-50 start-0 translate-middle-y d-block"
              style={{ width: '45%' }}
            >
              <TextLoading height={14} />
            </span>
          </>
        ) : (
          <span>{countSuffix(Number(count ?? 0))}</span>
        )}
      </div>
      <div className="text-secondary small d-inline-flex align-items-center gap-1">
        <span>تعداد بک‌لینک</span>
        <HelpTooltip html="تعداد کل بک‌لینک‌های شناسایی‌شده برای آدرس یا دامنه انتخاب‌شده." />
      </div>
    </IndexerKpiCard>
  );
};

BackLinkCount.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loading: PropTypes.bool
};

export default BackLinkCount;
